<template>
  <div>
    <!-- Modal for login error -->
    <Modal title="Invalid Credentials" ref="loginErrorModal">
      <template v-slot:body>
        Please check that you're using the correct username and password. For help, please email
        <a href="mailto:founders@muvve.com?subject=Request%20to%20register%20as%20Muvve%20event%20host%20">founders@muvve.com</a>
      </template>
    </Modal>

    <!-- Row for copy on left and login form on right -->
    <div class="top-section">
      <!-- Copy and login form -->
      <div class="container limit-width my-4">
        <div class="row">
          <div class="col-sm-6 col-md-6 col-lg-6 top-paragraph">
            <h1 class="display-4 mb-3">Start hosting</h1>
            <p class="lead">Muvve makes it easy to boost your events' visibility and attendance.</p>
            <p>With this site you can add new events to the Muvve platform, instantly sharing your event with hundreds of users. <a href="https://muvve.com" role="button" target="_blank">Learn more</a></p>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="jumbotron shade login-jumbotron">
              <h4 class="text-center ultra-light-weight mt-4 mb-3">Log In</h4>
              <form id="login-form" @submit.prevent="login">
                <div class="form-group">
                  <p class="lead">Email</p>
                  <input v-model="email" type="email" class="form-control" name="email" required>
                </div>
                <div class="form-group">
                  <p class="lead">Password</p>
                  <input v-model="password" type="password" class="form-control" name="password" required>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary mt-3">Log In</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Row for "Why Muvve" -->
    <div class="container limit-width my-4 content">
      <br><br>
      <h2>Why Muvve?</h2>
      <br><br>
      <div class="row">
        <div class=col-md-4>
          <font-awesome-icon icon="location-arrow" class="mb-3"/>
          <h3>Boost Your Event Visibility</h3>
          <p>Muvve will instantly allow your event to be viewed by a targeted demographic of users in your city.</p>
        </div>
        <br><br>
        <div class=col-md-4>
          <font-awesome-icon icon="users" class="mb-3"/>
          <h3>Get Access to Muvve Services</h3>
          <p>By signing up, you can use our mobile e-commerce platform or our event sales and marketing services.</p>
        </div>
        <br><br>
        <div class=col-md-4>
          <font-awesome-icon icon="money-bill-alt" class="mb-3"/>
          <h3>Get Paid, Without Hassle</h3>
          <p>After your event, your profits will get sent straight to your bank account. Plain and Simple.</p>
        </div>
      </div>
      <hr class="mt-4">
    </div>

    <!-- Previous events photos -->
    <div class="container content">
      <h2>Check out previous events we've partnered with:</h2>
      <br><br>
      <div id="pastEventsPhotosCarousel" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#pastEventsPhotosCarousel" data-slide-to="0" class="active"></li>
          <li data-target="#pastEventsPhotosCarousel" data-slide-to="1"></li>
          <li data-target="#pastEventsPhotosCarousel" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img class="d-block w-100" src="../assets/images/past_event_1.jpg">
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="../assets/images/past_event_2.jpg">
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="../assets/images/past_event_3.jpg">
          </div>
        </div>
        <a class="carousel-control-prev" href="#pastEventsPhotosCarousel" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#pastEventsPhotosCarousel" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>

    <!-- Social footer -->
    <footer class="mb-4">
      <div class="container content">
        <span>
          <a class="px-2" href="https://www.facebook.com/muvvement" target=_blank>
            <font-awesome-icon :icon="['fab', 'facebook-square']"/>
          </a>
          <a class="px-2" href="https://www.instagram.com/muvvement" target=_blank>
            <font-awesome-icon :icon="['fab', 'instagram']"/>
          </a>
          <a href="https://angel.co/muvve" target=_blank>
            <font-awesome-icon :icon="['fab', 'angellist']"/>
          </a>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import Modal from '../components/Modal'
import { tryLogin } from '../mixins/auth'
import { Store } from '../store'

export default {
  components: {
    Modal: Modal
  },
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    showLoginErrorModal () {
      this.$refs.loginErrorModal.show()
    },
    login () {
      tryLogin(this.email, this.password)
        .then(host => {
          Store.setHost(host)
          if (this.loggedIn) {
            this.$router.replace('/home')
          }
        })
        .catch(this.showLoginErrorModal)
    }
  }
}
</script>

<style scoped>
.top-section {
  background-color: var(--Muvve-blue);
  margin-top: -25px;
  padding-top: 25px;
  padding-bottom: 25px;
}

.top-paragraph {
  margin-top: 6%;
}

.limit-width {
  max-width: 1220px;
}

.login-jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 0;
}

.content {
  text-align: center;
  margin-top: 100px;
}

svg {
  font-size: 60px;
}

</style>
